<div [kalLoading]="loading"
     kalDialogContent>

    <p>
        L'écriture est lettrée. Sa suppression entraînera la suppression du lettrage des écritures situées ci-dessous.
    </p>

    <kal-table
        [columns]="columns"
        [dataSource]="dataSource"
        class="no-action">

        <tr *kalHeaderRowDef kal-header-row></tr>
        <tr *kalFooterRowDef kal-footer-row></tr>

        <ng-container kalColumn="DateEcriture">
            <td *kalBodyCell="let element">{{ element.DateEcriture | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container kalColumn="NomPrenomBenef">
            <td *kalBodyCell="let element">{{ element.NomPrenomBenef || element.NomFournisseur }}</td>
        </ng-container>

        <ng-container kalColumn="Debit">
            <td *kalBodyCell="let element">{{ element.Debit | currency:'EUR' }}</td>
        </ng-container>

        <ng-container kalColumn="Credit">
            <td *kalBodyCell="let element">{{ element.Credit | currency:'EUR' }}</td>
        </ng-container>

    </kal-table>

</div>

<div kalDialogFooter>

    <kal-button (click)="submit()"
                kalTheme="primary">
        Valider
    </kal-button>

    <kal-button (click)="close()"
                kalTheme="secondary">
        Annuler
    </kal-button>

</div>
